import React, { useContext, useEffect, useState } from "react";
import { DonationContext } from "../../context/DonationContext";
import { LanguageContext } from "../../context/LanguageContext";
import { motion } from "framer-motion";

const DynamicPrice = () => {
  const { t } = useContext(LanguageContext);
  const [basePrice, setBasePrice] = useState(0);
  const [tokensSold, setTokensSold] = useState(0);
  const [loading, setLoading] = useState(true);
  const { refreshFlag } = useContext(DonationContext);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/token/metrics`);
        const data = await res.json();
        if (res.ok) {
          setBasePrice(data.base_price);
          setTokensSold(data.tokens_sold);
        } else {
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/token/metrics`);
        const data = await res.json();
        if (res.ok) {
          setBasePrice(data.base_price);
          setTokensSold(data.tokens_sold);
        } else {
          console.error("Error:", data.message);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [refreshFlag]);

  const newPrice = basePrice + (tokensSold / 1_000_000) * 0.001;
  const totalRaised = tokensSold;

  return (
    <section className="py-10 bg-gray-100 text-center">
      <h2 className="text-2xl font-semibold mb-6">{t("token_price_heading")}</h2>

      {loading ? (
        <p className="text-gray-500">{t("loading")}...</p>
      ) : (
        <motion.div
          className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4 px-4"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Current Price Card */}
          <div
            className="bg-white shadow-lg rounded-xl p-6 w-full max-w-xs md:w-64 transform transition-transform duration-300 hover:scale-105"
          >
            <p className="text-gray-500 text-sm mb-2">{t("current_price")}</p>
            <p className="text-2xl font-bold text-green-600">€{newPrice.toFixed(3)}</p>
          </div>

          {/* Total Raised Card */}
          <div
            className="bg-white shadow-lg rounded-xl p-6 w-full max-w-xs md:w-64 transform transition-transform duration-300 hover:scale-105"
          >
            <p className="text-gray-500 text-sm mb-2">{t("total_raised")}</p>
            <p className="text-2xl font-bold text-blue-600">
              {Math.floor(totalRaised).toLocaleString("de-DE")}
            </p>
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default DynamicPrice;
